// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/static/" + chunkId + "." + "29edde330b7c1f2c02dad441bc7ed06671f26a5541c1b7684f47eb632feb3f93" + ".css";
};